// Save Big On Tires — bounded button compatibility helpers.
(function(){
  'use strict';
  function init(){
    var pendingTimer=null;
    function fixAllButtons(){
      var buttons=document.querySelectorAll(
        '.btn--add-to-cart, .book-now-button, [name="add"], [type="submit"][value*="cart"], ' +
        'button[onclick*="cart"], .product-form button, .product-single__form button, ' +
        '.savebigontires-cart-btn, .savebigontires-mobile-cart-btn, .cart-toggle'
      );
      buttons.forEach(function(button){
        if(button.getAttribute('data-button-fixed')==='true') return;
        button.setAttribute('data-button-fixed','true');
        if(!button.disabled){button.style.pointerEvents='auto';button.style.opacity='1';}
        if(button.classList.contains('cart-toggle') || button.classList.contains('savebigontires-cart-btn') || button.classList.contains('savebigontires-mobile-cart-btn')){
          if(window.ajaxifyShopify || (window.jQuery && jQuery.fn && jQuery.fn.jquery)) return;
          button.addEventListener('click',function(e){e.preventDefault();window.location.href='/cart';});
          return;
        }
        if(button.classList.contains('btn--add-to-cart') || button.name==='add' || String(button.textContent||'').toLowerCase().includes('add to cart')){
          if(button.id==='headerAddToCart' || button.classList.contains('header-add-to-cart-button')) return;
          var form=button.closest('form');
          if(form && form.action && form.action.indexOf('/cart/add')!==-1){if(!form.method)form.method='post';return;}
          button.addEventListener('click',function(e){
            var anyForm=document.querySelector('form[action*="/cart/add"]') || document.querySelector('[id^="product-form-"]');
            if(anyForm){e.preventDefault(); if(typeof anyForm.requestSubmit==='function')anyForm.requestSubmit(); else anyForm.submit();}
          });
        }
      });
    }
    function scheduleFix(){
      if(pendingTimer)return;
      pendingTimer=setTimeout(function(){pendingTimer=null;fixAllButtons();},350);
    }
    fixAllButtons();
    setTimeout(fixAllButtons,1200);
    if(window.MutationObserver){
      var observer=new MutationObserver(function(mutations){
        for(var i=0;i<mutations.length;i++){
          if(mutations[i].addedNodes && mutations[i].addedNodes.length){scheduleFix();break;}
        }
      });
      observer.observe(document.body,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();